// src/components/Navbar.jsx - Updated with Orange-to-Pink Theme
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showBookmarksModal, setShowBookmarksModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [showAccountDropdown, setShowAccountDropdown] = useState(false);

  const userPhone = localStorage.getItem('userPhone') || '9810489101';

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/login');
  };

  const handleDashboard = () => {
    navigate('/dashboard');
    setShowAccountDropdown(false);
  };

  return (
    <>
      <nav className="modern-navbar">
        <div className="navbar-container">
          {/* Logo */}
          <div className="navbar-logo" onClick={() => navigate('/dashboard')}>
            <img 
              src="/logoLe.png" 
              alt="LJSoft Online" 
              className="logo-img"
            />
          </div>

          {/* Welcome Text */}
          <div className="navbar-welcome">
            Welcome : {userPhone}
          </div>

          {/* Right Actions */}
          <div className="navbar-actions">
            {/* Home Icon */}
            <button 
              className="nav-icon-btn"
              onClick={() => navigate('/dashboard')}
              title="Home"
            >
              <i className="bx bx-home-alt"></i>
            </button>

            {/* Bookmarks Icon */}
            <button 
              className="nav-icon-btn"
              onClick={() => setShowBookmarksModal(true)}
              title="Bookmarks"
            >
              <i className="bx bx-bookmarks"></i>
            </button>

            {/* Saved Icon */}
            <button 
              className="nav-icon-btn"
              onClick={() => navigate('/saveBookmarks')}
              title="Saved"
            >
              <i className="bx bx-bookmark"></i>
            </button>

            {/* Settings Icon */}
            <button 
              className="nav-icon-btn"
              onClick={() => setShowSettingsModal(true)}
              title="Settings"
            >
              <i className="bx bx-cog"></i>
            </button>

            {/* My Account Dropdown */}
            <div className="account-dropdown-wrapper">
              <button 
                className="account-btn"
                onClick={() => setShowAccountDropdown(!showAccountDropdown)}
              >
                <i className="bx bx-user-circle"></i>
                <span>My Account</span>
                <i className={`bx bx-chevron-down ${showAccountDropdown ? 'rotated' : ''}`}></i>
              </button>

              {showAccountDropdown && (
                <div className="account-dropdown">
                  <button onClick={handleDashboard}>
                    <i className="bx bx-grid-alt"></i>
                    Dashboard
                  </button>
                  <button onClick={() => navigate('/profile')}>
                    <i className="bx bx-user"></i>
                    Profile
                  </button>
                  <button onClick={handleLogout}>
                    <i className="bx bx-log-out"></i>
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* Modals remain the same */}
      {showBookmarksModal && (
        <>
          <div
            className="modal-backdrop"
            onClick={() => setShowBookmarksModal(false)}
          ></div>
          <div className="modal fade show d-block" style={{ zIndex: 1060 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <div className="d-flex align-items-center">
                    <div className="modal-icon-wrapper">
                      <i className="bx bx-bookmarks"></i>
                    </div>
                    <h4 className="modal-title mb-0">Bookmarks</h4>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowBookmarksModal(false)}
                  ></button>
                </div>
                <div className="modal-body text-center py-5">
                  <div className="mb-4">
                    <i className="bx bx-time-five text-muted" style={{ fontSize: '4rem' }}></i>
                  </div>
                  <h3 className="text-muted mb-3">Coming Soon</h3>
                  <p className="text-muted mb-0">
                    Bookmarks feature is under development and will be available soon.
                  </p>
                </div>
                <div className="modal-footer border-0 justify-content-center">
                  <button
                    type="button"
                    className="btn btn-primary px-4"
                    onClick={() => setShowBookmarksModal(false)}
                  >
                    Got it
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {showSettingsModal && (
        <>
          <div
            className="modal-backdrop"
            onClick={() => setShowSettingsModal(false)}
          ></div>
          <div className="modal fade show d-block" style={{ zIndex: 1060 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <div className="d-flex align-items-center">
                    <div className="modal-icon-wrapper">
                      <i className="bx bx-cog"></i>
                    </div>
                    <h4 className="modal-title mb-0">Settings</h4>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowSettingsModal(false)}
                  ></button>
                </div>
                <div className="modal-body text-center py-5">
                  <div className="mb-4">
                    <i className="bx bx-time-five text-muted" style={{ fontSize: '4rem' }}></i>
                  </div>
                  <h3 className="text-muted mb-3">Coming Soon</h3>
                  <p className="text-muted mb-0">
                    Settings panel is under development.
                  </p>
                </div>
                <div className="modal-footer border-0 justify-content-center">
                  <button
                    type="button"
                    className="btn btn-primary px-4"
                    onClick={() => setShowSettingsModal(false)}
                  >
                    Got it
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <style>{`
        /* Modern Navbar - Orange to Pink Theme */
        .modern-navbar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          background: white;
          border-bottom: 2px solid #f0f0f0;
          z-index: 1000;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        }

        .navbar-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 24px;
          max-width: 100%;
          margin: 0 auto;
        }

        /* Logo */
        .navbar-logo {
          cursor: pointer;
          transition: transform 0.3s ease;
        }

        .navbar-logo:hover {
          transform: scale(1.05);
        }

        .logo-img {
          height: 50px;
          width: auto;
        }

        /* Welcome Text */
        .navbar-welcome {
          font-size: 15px;
          font-weight: 600;
          color: #333;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        /* Right Actions */
        .navbar-actions {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        /* Icon Buttons - Orange to Pink Gradient */
        .nav-icon-btn {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          border: 2px solid #f0f0f0;
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .nav-icon-btn i {
          font-size: 22px;
          color: #E91E63;
          transition: all 0.3s ease;
          z-index: 1;
        }

        .nav-icon-btn::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, #E91E63, #c41849);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .nav-icon-btn:hover {
          border-color: transparent;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(245, 166, 35, 0.3);
        }

        .nav-icon-btn:hover::before {
          opacity: 1;
        }

        .nav-icon-btn:hover i {
          color: white;
        }

        /* Account Button - Gradient */
        .account-dropdown-wrapper {
          position: relative;
        }

        .account-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 20px;
          background: linear-gradient(135deg, #E91E63 0%, #c41849 100%);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(245, 166, 35, 0.3);
        }

        .account-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(233, 30, 99, 0.4);
        }

        .account-btn i:first-child {
          font-size: 20px;
        }

        .account-btn i.bx-chevron-down {
          font-size: 18px;
          transition: transform 0.3s ease;
        }

        .account-btn i.bx-chevron-down.rotated {
          transform: rotate(180deg);
        }

        /* Account Dropdown */
        .account-dropdown {
          position: absolute;
          top: calc(100% + 8px);
          right: 0;
          background: white;
          border-radius: 12px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
          min-width: 200px;
          overflow: hidden;
          z-index: 1001;
          border: 1px solid #f0f0f0;
        }

        .account-dropdown button {
          width: 100%;
          padding: 12px 20px;
          border: none;
          background: white;
          color: #333;
          font-size: 14px;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
          transition: all 0.2s ease;
          border-bottom: 1px solid #f5f5f5;
        }

        .account-dropdown button:last-child {
          border-bottom: none;
        }

        .account-dropdown button i {
          font-size: 18px;
          color: #E91E63;
          transition: all 0.2s ease;
        }

        .account-dropdown button:hover {
          background: linear-gradient(90deg, rgba(245, 166, 35, 0.1), rgba(233, 30, 99, 0.05));
          color: #c41849;
        }

        .account-dropdown button:hover i {
          color: #c41849;
          transform: scale(1.1);
        }

        /* Modal Styles */
        .modal-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          z-index: 1055;
        }

        .modal-icon-wrapper {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #E91E63, #c41849);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;
        }

        .modal-icon-wrapper i {
          color: white;
          font-size: 20px;
        }

        .btn-primary {
          background: linear-gradient(135deg, #E91E63, #c41849);
          border: none;
          color: white;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(233, 30, 99, 0.4);
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .navbar-container {
            padding: 10px 16px;
          }

          .logo-img {
            height: 40px;
          }

          .navbar-welcome {
            font-size: 13px;
          }

          .nav-icon-btn {
            width: 38px;
            height: 38px;
          }

          .nav-icon-btn i {
            font-size: 20px;
          }

          .account-btn {
            padding: 8px 16px;
            font-size: 14px;
          }

          .account-btn span {
            display: none;
          }
        }

        @media (max-width: 480px) {
          .navbar-actions {
            gap: 8px;
          }

          .nav-icon-btn {
            width: 36px;
            height: 36px;
            border-width: 1px;
          }

          .nav-icon-btn i {
            font-size: 18px;
          }
        }
      `}</style>
    </>
  );
};

export default Navbar;